let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("39IYm")).then(() => parcelRequire('9PBZj'));